export default __webpack_public_path__ + "1af91b67986e91ce1f5cc7c3f3e96588.png";